module.exports = __webpack_public_path__ + "bquote.png?75fab52850a8675047c399dc072c46ca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bquote.png
// module id = 7
// module chunks = 0